import React, { useState, useEffect } from "react";
import uuid from "react-uuid";
import { addData, deleteData, getData } from "../service/APIService";
import "../styles/Setting.css";

const ToDoSettings = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [email, setEmail] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const sessionUser = JSON.parse(localStorage.getItem("loggedInUser"));
    const guestUser = JSON.parse(localStorage.getItem("guestUser"));
    if (sessionUser) {
      setIsLoggedIn(true);
      setEmail(sessionUser.email);
      loadCategoriesFromServer(sessionUser.email);
    } else {
      setIsLoggedIn(false);
      setEmail(guestUser?.email || "guest");
      loadCategoriesFromLocalStorage();
    }
  }, []);

  const loadCategoriesFromLocalStorage = () => {
    const savedCategories = JSON.parse(localStorage.getItem("todoCategories")) || [];
    setCategories(savedCategories);
  };

  const loadCategoriesFromServer = async (userEmail) => {
    setLoading(true);
    try {
      const response = await getData(userEmail, "todocategory");
      const categoriesWithIds = response?.map((item) => ({
        id: item.id || uuid(),
        name: typeof item === "object" ? item.name : item,
      }));
      setCategories(categoriesWithIds || []);
    } catch (error) {
      console.error("Failed to load categories from server:", error);
    } finally {
      setLoading(false);
    }
  };

  const addCategory = async (e) => {
    if (e) e.preventDefault();
    if (newCategory.trim() === "") return alert("Category name cannot be empty!");
    const categoryToAdd = newCategory.trim().toUpperCase();

    if (categories.some((c) => c.name?.toUpperCase() === categoryToAdd)) {
      return alert("Category already exists!");
    }

    const newCategoryObject = {
      id: uuid(),
      name: categoryToAdd,
      type: "todocategory",
    };

    if (isLoggedIn) {
      setLoading(true);
      try {
        await addData({ ...newCategoryObject, email });
        loadCategoriesFromServer(email);
      } catch (error) {
        console.error("Failed to add category to server:", error);
      } finally {
        setLoading(false);
      }
    } else {
      const updatedCategories = [...categories, newCategoryObject];
      setCategories(updatedCategories);
      localStorage.setItem("todoCategories", JSON.stringify(updatedCategories));
    }
    setNewCategory("");
  };

  const deleteCategory = async (categoryId) => {
    if (!window.confirm("Are you sure you want to delete this category?")) return;

    if (isLoggedIn) {
      try {
        await deleteData(categoryId);
        loadCategoriesFromServer(email);
      } catch (error) {
        console.error("Failed to delete category from server:", error);
      }
    } else {
      const updatedCategories = categories.filter((c) => c.id !== categoryId);
      setCategories(updatedCategories);
      localStorage.setItem("todoCategories", JSON.stringify(updatedCategories));
    }
  };

  return (
    <div className="settings-card">
      <div className="settings-card-header">
        <div className="settings-card-icon">
          <i className="fi fi-rr-list-check"></i>
        </div>
        <div className="flex-grow-1">
          <div className="d-flex justify-content-between align-items-center">
            <h4 className="settings-card-title">Task Categories</h4>
            <span
              style={{
                fontSize: "11px",
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: "12px",
                background: "var(--accent-mauve-soft)",
                color: "var(--primary-deep)",
              }}
            >
              {categories.length} Categories
            </span>
          </div>
          <p className="settings-card-subtitle">
            Organize your To-Do tasks into custom lists
          </p>
        </div>
      </div>

      <form onSubmit={addCategory} className="d-flex gap-2 mb-3">
        <input
          type="text"
          placeholder="e.g. Work, Shopping, Fitness"
          value={newCategory}
          onChange={(e) => setNewCategory(e.target.value)}
          className="modern-input"
          style={{ height: "44px" }}
        />
        <button
          type="submit"
          className="btn-coral-modern"
          disabled={loading || !newCategory.trim()}
          style={{ width: "auto", padding: "0 18px", whiteSpace: "nowrap", height: "44px" }}
        >
          <i className="fi fi-rr-plus"></i> Add
        </button>
      </form>

      {loading ? (
        <div className="text-center py-3">
          <i className="fi fi-rr-spinner fa-spin" style={{ color: "var(--accent-mauve)" }}></i>
        </div>
      ) : categories.length === 0 ? (
        <p style={{ fontSize: "13px", color: "var(--text-muted)", textAlign: "center", margin: "16px 0" }}>
          No custom task categories yet. Add your first one above!
        </p>
      ) : (
        <div className="d-flex flex-column">
          {categories.map((category) => (
            <div key={category.id} className="settings-cat-item">
              <div className="settings-cat-name">
                <i className="fi fi-rr-bookmark" style={{ color: "var(--accent-mauve)" }}></i>
                <span>{category.name}</span>
              </div>
              <button
                type="button"
                className="settings-delete-btn"
                onClick={() => deleteCategory(category.id)}
                title="Delete category"
              >
                <i className="fi fi-rr-trash"></i>
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ToDoSettings;
